export default __webpack_public_path__ + "static/media/04__o_preview_1.efc99a56.jpg";